/** A hero section's "Heading size" display setting, as the class that carries
 *  it. Standard is the design system's base h1; the two larger steps are its
 *  hero classes, so the sizes stay in the stylesheet rather than in a page. */
export function headingSizeClass(size?: string | null): string {
  switch (size) {
    case "large":
      return "text-hero"
    case "xl":
      return "text-hero-xl"
    default:
      return ""
  }
}
